// @ts-nocheck
import React from 'react';
import styled from 'styled-components';

import { Row, Col } from 'crehana-ui/GridV2';
import CheckNew from 'crehana-icons/CheckNew';
import Minus from 'crehana-icons/Minus';
import {
  baseMain,
  white,
  yellowMain,
  secondaryDark,
} from 'crehana-ui/styles/colors';

import { Benefit } from '../types';

const Section = styled.section<{ isEven: boolean }>`
  position: relative;
  &:before,
  &:after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    background-color: ${props => (props.isEven ? baseMain : 'transparent')};
    min-height: 207px;
    height: 100%;
    max-height: 295px;
  }
  &:before {
    width: 10%;
    transform: translateX(-99%);
    left: 0;
  }
  &:after {
    right: 0;
    transform: translateX(99%);
    width: 10%;
  }
`;

const renderAccessPlan = ({
  hasAccess,
  isHighlighted,
}: {
  hasAccess: boolean | string;
  isHighlighted: boolean;
}) => {
  if (hasAccess) {
    return typeof hasAccess === 'string' ? (
      <span
        className={`${
          isHighlighted ? 'text-yellow-main' : 'text-white'
        } font-body3`}
      >
        {hasAccess}
      </span>
    ) : (
      <span>
        <CheckNew size={24} color={isHighlighted ? yellowMain : white} />
      </span>
    );
  }
  return <Minus size={16} color={secondaryDark} />;
};

const MobileBenefits: React.FC<{
  benefit: Benefit;
  className?: string;
  indexChildren: number;
}> = ({
  benefit: {
    title,
    description,
    FREE_PLAN: freePlan,
    PREMIUM: individualPlan,
    PREMIUM_DUO: duoPlan,
    FAMILIAR: familyPlan,
  },
  className,
  indexChildren,
}) => {
  const isEven = Boolean((indexChildren + 1) % 2);

  return (
    <Section
      className={`${isEven ? 'bg-base-main' : ''}   ${className}`}
      isEven={isEven}
    >
      <header>
        <h3 className="font-subtitle1 mb-4">{title}</h3>
      </header>
      <p className="font-body2 text-gray-main mb-40">{description}</p>
      <Row className="mb-8">
        <Col xs={3} sm={3} md={2} lg={2}>
          <h4
            className={`font-subtitle4 text-center ${
              freePlan.isHighlighted ? 'text-yellow-main' : ''
            }`}
          >
            {freePlan.planName}
          </h4>
        </Col>
        <Col xs={3} sm={3} md={2} lg={2}>
          <h4
            className={`font-subtitle4 text-center ${
              individualPlan.isHighlighted ? 'text-yellow-main' : ''
            }`}
          >
            {individualPlan.planName}
          </h4>
        </Col>
        <Col xs={3} sm={3} md={2} lg={2}>
          <h4
            className={`font-subtitle4 text-center ${
              duoPlan.isHighlighted ? 'text-yellow-main' : ''
            }`}
          >
            {duoPlan.planName}
          </h4>
        </Col>
        <Col xs={3} sm={3} md={2} lg={2}>
          <h4
            className={`font-subtitle4 text-center ${
              familyPlan.isHighlighted ? 'text-yellow-main' : ''
            }`}
          >
            {familyPlan.planName}
          </h4>
        </Col>
      </Row>
      <Row>
        <Col xs={3} sm={3} md={2} lg={2}>
          <p className="text-center">
            {freePlan.hasAccess ? (
              <CheckNew size={24} color={white} />
            ) : (
              <Minus size={16} color={secondaryDark} />
            )}
          </p>
        </Col>
        <Col xs={3} sm={3} md={2} lg={2}>
          <p className="text-center">
            {individualPlan.hasAccess ? (
              <span>
                <CheckNew size={24} color={white} />
              </span>
            ) : (
              <Minus size={16} color={secondaryDark} />
            )}
          </p>
        </Col>
        <Col xs={3} sm={3} md={2} lg={2}>
          <p className="text-center">{renderAccessPlan(duoPlan)}</p>
        </Col>
        <Col xs={3} sm={3} md={2} lg={2}>
          <p className="text-center">{renderAccessPlan(familyPlan)}</p>
        </Col>
      </Row>
    </Section>
  );
};

export default MobileBenefits;
